<script>
import {StudyStage} from '@/store/models/study';

export default {
   name: 'StageSelect',
   props: {
      selectedStage: {
         type: String,
      },
   },

   methods: {
      async onSelect(item) {
         const data = {item};
         if (
            this.previouslySelected === StudyStage.RDIG_STUDY_SETUP &&
            item === StudyStage.CLIENT_DATA_COLLECTION
         ) {
            const doSend = await this.$bvModal.msgBoxConfirm(
               "Do you want to send an e-mail to this company's users notifying them that we are ready for QRE data entry?",
               {
                  title: 'Notify the client?',
                  centered: true,
                  okTitle: 'Send',
                  cancelTitle: 'Do not send',
               }
            );
            if (doSend) {
               data.notify = true;
            }
         }
         this.previouslySelected = this.selected;
         this.$emit('onSelect', data);
      },
   },

   data() {
      return {
         selected: this.selectedStage,
         previouslySelected: this.selectedStage,
         options: [
            {value: StudyStage.CLIENT_INFO_COLLECTION, text: 'Client Info Collection'},
            {value: StudyStage.RDIG_STUDY_SETUP, text: 'RDIG Study Setup'},
            {value: StudyStage.CLIENT_DATA_COLLECTION, text: 'Client Data Collection'},
            {value: StudyStage.RDIG_DATA_REVIEW, text: 'RDIG Data Review'},
            {value: StudyStage.RDIG_CREDIT_CALCULATION, text: 'RDIG Credit Calculation'},
            {value: StudyStage.DELIVERED, text: 'Delivered'},
         ],
      };
   },
};
</script>

<template>
   <b-form-select
      v-model="selected"
      :options="options"
      size="sm"
      @change="onSelect"
   ></b-form-select>
</template>

<style scoped lang="scss"></style>
